import Input, { Textarea } from '../ui/Input';
import KeywordInput from '../ui/KeywordInput';
import Tooltip from '../ui/Tooltip';
import './WizardStep.css';

const MISSION_TOOLTIP = `Tell us everything about your brand:
• What your brand/product does
• What problem it solves
• Your target audience
• Similar websites you like (e.g., "like Stripe but for...")
• Any specific features or sections you want
• The overall feeling you want visitors to have`;

export default function StepBrandCore({ formData, errors, onChange }) {
  const { brandCore } = formData;

  const handleChange = (field, value) => {
    onChange('brandCore', field, value);
  };

  return (
    <div className="wizard-step">
      <div className="wizard-step__header">
        <h2 className="wizard-step__title">Tell us about your brand</h2>
        <p className="wizard-step__description">
          Start with the fundamentals — your brand's identity and what makes it unique.
        </p>
      </div>

      <div className="wizard-step__content">
        <Input
          label="Brand Name"
          placeholder="Enter your brand or project name"
          value={brandCore.name}
          onChange={(e) => handleChange('name', e.target.value)}
          error={errors.name}
          maxLength={100}
        />

        <div className="field-with-tooltip">
          <Textarea
            label={
              <span className="label-with-tooltip">
                Mission Statement
                <Tooltip content={MISSION_TOOLTIP}>?</Tooltip>
              </span>
            }
            placeholder="What's your brand's purpose? What problem does it solve? Include any websites you'd like it to be similar to..."
            value={brandCore.mission}
            onChange={(e) => handleChange('mission', e.target.value)}
            error={errors.mission}
            maxLength={280}
            rows={4}
            hint="Include everything: purpose, inspiration, similar sites you like"
          />
        </div>

        <KeywordInput
          label="Vibe Keywords"
          values={brandCore.vibeKeywords}
          onChange={(values) => handleChange('vibeKeywords', values)}
          error={errors.vibeKeywords}
        />
      </div>
    </div>
  );
}
